import { AxiosResponse } from 'axios';

export interface ResponseError {
  error: any;
  status: number;
  data: [];
}

export interface Headers {
  'hcaptcha-token'?: string,
  'Content-Type'?: string,
  'FFF-Auth'?: string,
}

export interface Options {
  withCredentials?: boolean;
  headers?: Headers;
}

export function isResponseError(
  response: ResponseError | AxiosResponse,
): response is ResponseError {
  return 'error' in response;
}
